
import XTable from 'vux/src/components/x-table/index.vue'

import { mapMutations } from 'vuex'
export default {
name:'AphasiaClassification',
components: {
XTable,
},
data() {
return {
form:{
fluency:'0',
understanding:'0',
repetition:'0',
},
hasScore:false,
disabled:false,
defaultJson:{
"Anomic": "命名性失语",
"Global": "完全性失语",
"Mixed transcortical": "混合性失语",
"Conduction": "传导性失语",
"Fluent speech": "表达流利",
"Correct understanding": "理解正确",
"Good repetition": "重复性好",
"Wernicke's": "Wernicke 失语",
"Broca's": "Broca 失语",
"Motor transcortical": "运动性失语",
"Sensory transcortical": "感觉性失语"
},
}
},
created () {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad']),
},
computed: {
/** 计算主要标准 */
score() {
let self = this
let form = JSON.parse(JSON.stringify(self.form))
let flag = true
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (!form[key]) {
flag = false
form[key]=0
} else {
form[key] = Number(form[key])
}
}
}

let result = form.fluency ? (form.understanding ?	(form.repetition ? 1 : 2):(form.repetition ? 3 : 4)) : (form.understanding ?(form.repetition? 5 : 6) : (form.repetition ? 7 : 8))
self.hasScore = true
return String(result)
},
},


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/AphasiaClassification.vue